import { render, staticRenderFns } from "./MemoryPreview.vue?vue&type=template&id=18c52ec0&lang=pug&"
import script from "./MemoryPreview.vue?vue&type=script&lang=js&"
export * from "./MemoryPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports